import type { RouteRecordRaw } from 'vue-router'
import { ROUTES } from '@/router/routes.enum'
import { ACTION_ROLES } from '@/utils/constants'
import { requireAuthenticatedUser } from '@/router/guards'

export const decryptRoutes: RouteRecordRaw[] = [
  {
    path: '/decrypt',
    name: ROUTES.DECRYPT,
    component: () => import('@/modules/decrypt/views/DecryptIndex.view.vue'),
    beforeEnter: requireAuthenticatedUser,
    meta: { roles: ACTION_ROLES.DECRYPT_VIEW }
  }
]
